import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/site/Navbar";
import Hero from "./components/site/Hero";
import Services from "./components/site/Services";
import WhyChooseUs from "./components/site/WhyChooseUs";
import Portfolio from "./components/site/Portfolio";
import Testimonials from "./components/site/Testimonials";
import About from "./components/site/About";
import Whatsapp from "./components/site/Whatsapp";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";

function Home() {
  return (
    <main className="bg-[#050505] min-h-screen text-white" data-testid="home-page">
      <Navbar />
      <Hero />
      <Services />
      <WhyChooseUs />
      <Portfolio />
      <Testimonials />
      <About />
      <Whatsapp />
      <Contact />
      <Footer />
    </main>
  );
}

export default function App() {
  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0f0f0f",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#fafafa",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
